module.exports = __webpack_public_path__ + "img/image56.92524c10.jpg";